// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Ljug","requiredAsterisk":"Info_requiredAsterisk__1ibiR"};